// src/column.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Column = React.forwardRef(
  ({ children, style, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      "td",
      {
        ...props,
        ref: forwardedRef,
        "data-id": "__react-email-column",
        style,
        children
      }
    );
  }
);
export {
  Column
};
